module.exports = __webpack_public_path__ + "img/payment.48859d21.svg";